/**
 * bottomDockInset — the CSS custom property a bar pinned to the viewport's
 * bottom edge (the cookie consent bar) publishes with its height while it is
 * shown, so anything else docked to that edge (the /check next-step bar,
 * FAI-97) can sit clear of it. One name, shared by the publisher and every
 * consumer, so a rename cannot silently undock a bar.
 */

export const BOTTOM_DOCK_INSET_PROPERTY = "--fp-bottom-dock-inset";

/** Measured bar height plus breathing room for focus-scroll positioning. */
export const BOTTOM_SCROLL_RESERVE_PROPERTY = "--fp-bottom-scroll-reserve";

/** The `bottom` value for an element docked above whatever published the inset. */
export function bottomDockInset(): string {
  return `var(${BOTTOM_DOCK_INSET_PROPERTY}, 0px)`;
}
